import styled from 'styled-components'
import { DefaultFontStyle } from '../../../styles/global-styles'
interface BookingChipProps {
  deletable?: boolean
  assignable?: boolean
  selected?: boolean
}

export const ChipText = styled.span`
  ${DefaultFontStyle};
  font-weight: 400;
  font-size: 14px;
  display: flex;
  align-self: center;
  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    font-size: 10px;
    margin-top: 3px;
  }
`
export const BookingChip = styled.div<BookingChipProps>`
  box-sizing: border-box;
  width: fit-content;
  height: 31px;
  border: 1px solid #000000;
  border-radius: 30px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding-left: 13px;
  padding-right: ${props => (props.deletable ? null : '15px')};
  display: flex;
  flex-direction: row;
  align-self: center;
  white-space: nowrap;
  opacity: ${props => (props.deletable || props.assignable ? '100%' : '30%')};
  background-color: ${props => (props.selected ? '#D9D9D9' : 'white')};
  &:hover {
    background-color: ${props => (props.assignable ? '#D9D9D9' : 'white')};
    cursor: ${props => (props.assignable ? 'pointer' : null)};
  }
`

export const OrganiserBookingChip = styled(BookingChip)`
  width: fit-content;
  height: 43px;
  flex-direction: column;
  padding-right: 30px;
  justify-content: center;
  opacity: 100%;
`

export const CancelButton = styled.button`
  width: 23px;
  height: 23px;
  align-content: center;
  justify-content: center;
  background: none;
  border: 0px;
  align-self: center;
  padding-right: 25px;
  cursor: pointer;
`

export const CancelIcon = styled.img`
  width: 23px;
  height: 23px;
`

export const OrganiserText = styled(ChipText)`
  align-self: flex-start;
  font-size: 10px;
  color: #33a83f;
`
